export const PROCESS_FETCH_TRENDING = 'PROCESS_FETCH_TRENDING';
export const FETCH_TRENDING_SUCCESS = 'FETCH_TRENDING_SUCCESS';
export const FETCH_TRENDING_FAILED = 'FETCH_TRENDING_FAILED';
